/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Per-block visual design controls
 * @export
 * @interface SurfaceBlockDesign
 */
export interface SurfaceBlockDesign {
    /**
     * 
     * @type {string}
     * @memberof SurfaceBlockDesign
     */
    backgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceBlockDesign
     */
    backgroundImageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceBlockDesign
     */
    backgroundGradient?: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceBlockDesign
     */
    backgroundOverlayOpacity?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceBlockDesign
     */
    padding?: SurfaceBlockDesignPaddingEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceBlockDesign
     */
    fullBleed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurfaceBlockDesign
     */
    textAlignment?: SurfaceBlockDesignTextAlignmentEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceBlockDesign
     */
    borderTop?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceBlockDesign
     */
    borderBottom?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceBlockDesign
     */
    roundedCorners?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SurfaceBlockDesign
     */
    animateOnScroll?: SurfaceBlockDesignAnimateOnScrollEnum;
    /**
     * Resolved CDN URL for background image (read-only, populated from backgroundImageId)
     * @type {string}
     * @memberof SurfaceBlockDesign
     */
    backgroundImageUrl?: string;
}


/**
 * @export
 */
export const SurfaceBlockDesignPaddingEnum = {
    none: 'none',
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    xl: 'xl'
} as const;
export type SurfaceBlockDesignPaddingEnum = typeof SurfaceBlockDesignPaddingEnum[keyof typeof SurfaceBlockDesignPaddingEnum];

/**
 * @export
 */
export const SurfaceBlockDesignTextAlignmentEnum = {
    left: 'left',
    center: 'center',
    right: 'right'
} as const;
export type SurfaceBlockDesignTextAlignmentEnum = typeof SurfaceBlockDesignTextAlignmentEnum[keyof typeof SurfaceBlockDesignTextAlignmentEnum];

/**
 * @export
 */
export const SurfaceBlockDesignAnimateOnScrollEnum = {
    none: 'none',
    FadeUp: 'fade-up',
    FadeIn: 'fade-in',
    SlideLeft: 'slide-left',
    SlideRight: 'slide-right'
} as const;
export type SurfaceBlockDesignAnimateOnScrollEnum = typeof SurfaceBlockDesignAnimateOnScrollEnum[keyof typeof SurfaceBlockDesignAnimateOnScrollEnum];


/**
 * Check if a given object implements the SurfaceBlockDesign interface.
 */
export function instanceOfSurfaceBlockDesign(value: object): value is SurfaceBlockDesign {
    return true;
}

export function SurfaceBlockDesignFromJSON(json: any): SurfaceBlockDesign {
    return SurfaceBlockDesignFromJSONTyped(json, false);
}

export function SurfaceBlockDesignFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceBlockDesign {
    if (json == null) {
        return json;
    }
    return {
        
        'backgroundColor': json['backgroundColor'] == null ? undefined : json['backgroundColor'],
        'backgroundImageId': json['backgroundImageId'] == null ? undefined : json['backgroundImageId'],
        'backgroundGradient': json['backgroundGradient'] == null ? undefined : json['backgroundGradient'],
        'backgroundOverlayOpacity': json['backgroundOverlayOpacity'] == null ? undefined : json['backgroundOverlayOpacity'],
        'padding': json['padding'] == null ? undefined : json['padding'],
        'fullBleed': json['fullBleed'] == null ? undefined : json['fullBleed'],
        'textAlignment': json['textAlignment'] == null ? undefined : json['textAlignment'],
        'borderTop': json['borderTop'] == null ? undefined : json['borderTop'],
        'borderBottom': json['borderBottom'] == null ? undefined : json['borderBottom'],
        'roundedCorners': json['roundedCorners'] == null ? undefined : json['roundedCorners'],
        'animateOnScroll': json['animateOnScroll'] == null ? undefined : json['animateOnScroll'],
        'backgroundImageUrl': json['backgroundImageUrl'] == null ? undefined : json['backgroundImageUrl'],
    };
}

export function SurfaceBlockDesignToJSON(json: any): SurfaceBlockDesign {
    return SurfaceBlockDesignToJSONTyped(json, false);
}

export function SurfaceBlockDesignToJSONTyped(value?: SurfaceBlockDesign | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'backgroundColor': value['backgroundColor'],
        'backgroundImageId': value['backgroundImageId'],
        'backgroundGradient': value['backgroundGradient'],
        'backgroundOverlayOpacity': value['backgroundOverlayOpacity'],
        'padding': value['padding'],
        'fullBleed': value['fullBleed'],
        'textAlignment': value['textAlignment'],
        'borderTop': value['borderTop'],
        'borderBottom': value['borderBottom'],
        'roundedCorners': value['roundedCorners'],
        'animateOnScroll': value['animateOnScroll'],
        'backgroundImageUrl': value['backgroundImageUrl'],
    };
}

